import { motion } from "framer-motion";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { useLang } from "@/context/LanguageContext";

export default function FAQ() {
  const { t } = useLang();
  const faqs = t("faq.items");
  return (
    <section id="faq" className="relative py-24 max-w-3xl mx-auto px-5 sm:px-8">
      <div className="text-center mb-14">
        <p className="font-hand text-3xl text-accent mb-2">{t("faq.kicker")}</p>
        <h2 className="font-display font-bold text-4xl sm:text-5xl tracking-tight text-foreground">{t("faq.title")}</h2>
      </div>
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-${i}`} className="rounded-3xl bg-white border border-white shadow-glass px-6 overflow-hidden">
              <AccordionTrigger className="font-display font-semibold text-lg text-foreground hover:no-underline text-left">{f.q}</AccordionTrigger>
              <AccordionContent className="text-foreground/65 font-medium text-base">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </section>
  );
}
